import Stream from './containers/Stream';
import pageLayoutHoc from '../../hocs/pageLayoutHoc';
export const streamRoutes = [
  {
    path: '/pulse',
    component: pageLayoutHoc(Stream),
    key: 'pulse',
  }
];
